
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/whatsapp",
      function () {
        return require("private-next-pages/android/whatsapp/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/whatsapp"])
      });
    }
  